export const EmailTemplates = {
  Welcome: "d-71b534f467804c1b858ceb17e54d47b8",
  AssessmentPurchased: "d-71b534f467804c1b858ceb17e54d47b8",
  SessionScheduled: "d-71b534f467804c1b858ceb17e54d47b8",
  SelfSessionScheduled: "d-71b534f467804c1b858ceb17e54d47b8",
  UpcomingSession: "d-71b534f467804c1b858ceb17e54d47b8",
  ReferFriend: "d-71b534f467804c1b858ceb17e54d47b8",
  AssessmentNotification: "d-71b534f467804c1b858ceb17e54d47b8",
  CustomReminder: "d-71b534f467804c1b858ceb17e54d47b8",
  Invoice: "d-71b534f467804c1b858ceb17e54d47b8",
  Contact: "d-71b534f467804c1b858ceb17e54d47b8",
  TeamCoachPerformanceResult: "d-71b534f467804c1b858ceb17e54d47b8",
  TeamCoachPerformanceFormLink: "d-71b534f467804c1b858ceb17e54d47b8",
  PreSessionForm: "d-71b534f467804c1b858ceb17e54d47b8",
  FirstQuestionaire: "d-71b534f467804c1b858ceb17e54d47b8",
  FreeDiscoveryCall: "d-71b534f467804c1b858ceb17e54d47b8",
  RemoveAccount: "d-71b534f467804c1b858ceb17e54d47b8",
};

export const EmailEvents = {
  Welcome: "welcome",
  AssessmentPurchased: "assessment_purchased",
  SessionScheduled: "meeting_scheduled",
  SelfSessionScheduled: "self_meeting_scheduled",
  UpcomingSession: "upcoming_meeting",
  ReferFriend: "refer_friend",
  AssessmentNotification: "assessment_notification",
  CustomReminder: "custom_reminder",
  Invoice: "invoice",
  Contact: "contact",
  FreeDiscoveryCall: "free_discovery_call",
  EnterpriseContact: "enterprise_contact",
  TeamCoachPerformance: "team_coach_performance",
  TeamCoachPerformanceLink: "team_coach_performance_link",
  PreSessionForm: "pre_session_form",
  FirstQuestionaire: "first_questionaire",
  RemoveAccount: "remove_account",
  CustomForm: "custom_form",
};
